<template lang="pug">
	div
		#sfc-main-container
			sfc-sentry
			sfc-gtm-body
			sfc-dfp
			sfc-heap
			sfc-header
			#sfc-main-content
				nuxt
			no-ssr
				sfc-gdpr-banner
		no-ssr
			sfc-college-savings-questions-modal
</template>

<script>
	import SfcHeader from '@/layouts/common/redesign-v1/sfc-header-no-nav'
	import sfcCollegeSavingsQuestionsModal from '@/common/components/path/sfc-college-savings-questions-modal'

	export default {
		components: {
			SfcHeader,
			sfcCollegeSavingsQuestionsModal
		}
	}
</script>
